import { Component, Input, input, OnInit,OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-add-filters-button',
    templateUrl: './add-filters-button.component.html',
    styleUrl: './add-filters-button.component.scss',
    imports: [NgIf]
})
export class AddFiltersButtonComponent implements OnInit,OnChanges {
  isHierarchyFilterInitialised: boolean = false;
  // isAddfilterBtnEnabled: boolean = true;
  // isUniversalFilterEnabled: boolean = false;
  isUniversalFilterActive: boolean = false;
  // isHuddleFilterEnabled: boolean = false;
  isHuddleFilterActive: boolean = false;
  isAccount: boolean = false;
  accountId: string = '';
  projectId: string = '';
  activeTab: string = '';
  activeRoute: string = '';
  defaultHuddleFilterState: any = {
    "escalation": {},
    "spotlights": {},
    "actions": {}
  }
  @Input() isAddfilterBtnEnabled: boolean = false;
  @Input() isUniversalFilterEnabled:boolean = false;
  @Input() isHuddleFilterEnabled:boolean = false;
  constructor(
    private _filterService: GlobalFilterService,
    private _helpers: HelpersService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this._filterService.globalFilterState$.subscribe(() => {
      this.toggleButtonState();
    })
  }

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isAddfilterBtnEnabled'] || changes['isUniversalFilterEnabled'] || changes['isHuddleFilterEnabled']) {
      this._filterService.updateFilterVisiblity({
        isUniversalFilterEnabled: (this.isUniversalFilterEnabled) ? true : false,
        isAddfilterBtnEnabled: this.isAddfilterBtnEnabled,
        isHuddleFilterEnabled: this.isHuddleFilterEnabled
      });
    }
  }

  toggleButtonState() {
    this.isUniversalFilterActive = false;
    this.isHuddleFilterActive = false;
    let univeralFilters = this._filterService.getUniveralFilters()
    let huddleFilters = this._filterService.gethuddleFilters();
    // Draw active default access or Applied filter
    if (univeralFilters && univeralFilters.filters && univeralFilters.filters.length) {
      this.isUniversalFilterActive = true;
    }
    if (huddleFilters && !_.isEmpty(huddleFilters) && this.generateHash(this.defaultHuddleFilterState) != this.generateHash(huddleFilters)) {
      this.isHuddleFilterActive = true;
    }
  }

  updateFilterVisiblity(routeData: any) {
    const hideFilterOnRotue = ['engagement', 'outbox', 'sentiment-analysis'];
    const hideFilterOnTab = ['quickinsights']
    if (hideFilterOnRotue.indexOf(routeData.routeName) >= 0 || hideFilterOnTab.indexOf(routeData.active_tab) >= 0) {
      this.isAddfilterBtnEnabled = false;
      this.isUniversalFilterEnabled = false;
    } else {
      this.isAddfilterBtnEnabled = true;
      this.isUniversalFilterEnabled = true
    }
    if (routeData.routeName == "huddle") {
      this.isUniversalFilterEnabled = false;
      if (routeData.active_tab == "all-suggestions") {
        this.isAddfilterBtnEnabled = true;
        this.isHuddleFilterEnabled = true;
      }else{
        this.isAddfilterBtnEnabled = false;
        this.isHuddleFilterEnabled = false;
      }

    } 
    
    this._filterService.updateFilterVisiblity({
      isUniversalFilterEnabled: (this.isUniversalFilterEnabled) ? true : false,
      isAddfilterBtnEnabled: this.isAddfilterBtnEnabled,
      isHuddleFilterEnabled: this.isHuddleFilterEnabled
    });
  }

  openGlobalFilterSideBar(event: any, filterType: string) {
    if (event) event.preventDefault();
    let active_filter_tab = 'by_dimension';

    if (this.isHuddleFilterEnabled) {
      active_filter_tab = 'huddle_filter';
      filterType = 'huddle_filter';
    }
    const tabData = {
      tabName: active_filter_tab,
      filterType: filterType,
      isUniversalFilterEnabled: (this.isUniversalFilterEnabled) ? true : false,
      isHuddleFilterEnabled: this.isHuddleFilterEnabled
    };
    this._filterService.updateFilterVisiblity({
      tabName: active_filter_tab,
      filterType: filterType,
      isUniversalFilterEnabled: (this.isUniversalFilterEnabled) ? true : false,
      isHuddleFilterEnabled: this.isHuddleFilterEnabled
    });
    // Here need to pass selected option if user have multi value access
    this._filterService.openGlobalFilterPanel(tabData);
  }

  private generateHash(obj): string {
    if (obj !== undefined && !_.isEmpty(obj)) {
      return _.map(obj, (val, key) => { return `${key}-${JSON.stringify(val)}` }).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

}
